import { environment } from 'src/environments/environment';
import { OrganizationsService } from './organizations.service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ServiceBase {
    /** URL pour le webService */
    public baseUrl;

    /**
     * Constructeur
     */
    constructor() {
        if (environment.production) {
            this.baseUrl = '';
        } else {
            this.baseUrl = environment.serverUrl;
        }
    }
}
